import { useQuery } from "@tanstack/react-query";
import { fetchKashierSettings } from "../../api/PaymentAPIs";

export default function KashierInfoPage() {
  const { data, isLoading, error } = useQuery({ queryKey: ["kashierSettings"], queryFn: fetchKashierSettings });
  if (isLoading) return <p>جاري التحميل...</p>;
  if (error) return <p className="text-red-600">{error.message}</p>;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-5 space-y-3 text-sm leading-7">
      <h2 className="text-xl font-bold">Kashier</h2>
      <p>الدفع الأونلاين يستخدم جلسة دفع مستضافة. البطاقة وبيانات المحفظة لا تمر على سيرفر جراباتكم.</p>
      <p>في وضع الاختبار تعرض صفحة Kashier البطاقة والمحفظة حتى لو اختلف الإعداد المحلي. في الوضع الحي تُحترم الطرق المفعّلة هنا، بشرط تفعيلها أيضاً على حساب Kashier.</p>
      <p>المحفظة تحتاج تفعيل من Kashier على حساب التاجر. تفعيل WalletEnabled هنا لا يفتح المحفظة وحده.</p>
      <p>رابط الويبهوك الذي يجب تسجيله أو الذي يُرسل مع كل جلسة:</p>
      <code className="block bg-slate-50 rounded-lg p-3">{data?.webhookUrl}</code>
      <p>صفحة رجوع العميل:</p>
      <code className="block bg-slate-50 rounded-lg p-3">{data?.callbackUrl}</code>
    </div>
  );
}
